// extracted by mini-css-extract-plugin
module.exports = {"container":"PluginDetailsItem_container__1vc3W","src":"PluginDetailsItem_src__dQh5C","name":"PluginDetailsItem_name__20SuJ","id":"PluginDetailsItem_id__xZSiB"};